// 세션 메모리 응답 캐시(2026-07-18, "속도감" 피드백) — SWR(stale-while-revalidate) 방식.
//  · 3분 내 같은 요청: 네트워크 없이 즉시 반환 (기간 프리셋·탭·세그먼트를 오갈 때 0ms 체감)
//  · 3분 지난 요청: 캐시를 먼저 보여주고 뒤에서 조용히 갱신 (로딩 깜빡임 없음)
// 새로고침하면 비워지는 메모리 캐시라 데이터 정합성 리스크가 낮고, 크레딧 지급처럼
// 즉시성이 필요한 경로는 refreshTick 이 키에 들어가 자동으로 캐시를 우회한다.
const cache = new Map(); // key -> { data, ts }
const TTL_MS = 3 * 60 * 1000;
const MAX_ENTRIES = 100;

export function getCached(key) {
  return cache.get(key) || null;
}

export function isFresh(entry) {
  return Boolean(entry) && Date.now() - entry.ts < TTL_MS;
}

export function setCached(key, data) {
  if (cache.size >= MAX_ENTRIES) {
    // 가장 오래된 항목부터 제거(Map 은 삽입 순서 유지)
    cache.delete(cache.keys().next().value);
  }
  cache.set(key, { data, ts: Date.now() });
}

// 훅 밖(이벤트 핸들러식 fetch)에서 쓰는 헬퍼 — 신선하면 캐시, 아니면 호출 후 저장.
export async function cachedCall(key, fn) {
  const entry = cache.get(key);
  if (isFresh(entry)) return entry.data;
  const data = await fn();
  setCached(key, data);
  return data;
}

// 접두사로 캐시 무효화 — 지출 등록/삭제처럼 쓰기 직후 관련 조회(costs|…)를 강제 재조회할 때.
export function invalidateCache(prefix) {
  for (const key of cache.keys()) {
    if (key.startsWith(prefix)) cache.delete(key);
  }
}
